"use client"
import { motion } from 'framer-motion'
import { Container } from '../shared/container'
import { heroData, siteConfig } from '@/data/site-data'
import { Button } from '../ui/button'
import { ArrowUpRight } from 'lucide-react'
import Link from 'next/link'

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.6 }
  })
}

export default function Hero() {
  return (
    <section className="pt-24 lg:pt-[24svh] pb-20 min-h-svh relative overflow-visible! " id="home">
      <motion.div
        className="absolute w-full h-full hidden md:block"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      >
        <video src="/videos/10.mp4" autoPlay loop muted playsInline className="object-cover h-full w-full absolute opacity-60" style={{ display: 'block', filter: 'brightness(0.6) saturate(0) contrast(1.4)', mixBlendMode: 'screen' }} />
        <video src="/videos/10.mp4" autoPlay loop muted playsInline className="object-cover h-full w-full absolute opacity-20 blur" style={{ display: 'block', filter: 'hue-rotate(200deg) saturate(1.5) brightness(1)', mixBlendMode: 'screen' }} />
        <video src="/videos/10.mp4" autoPlay loop muted playsInline className="object-cover h-full w-full absolute opacity-20 blur" style={{ display: 'block', filter: 'hue-rotate(10deg) saturate(1.2) brightness(1.1)', mixBlendMode: 'screen' }} />
        <div className="absolute h-[102%] w-full bg-linear-to-b to-background via-background/40 from-background" />
      </motion.div>

      <Container>
        <motion.div
          className="max-w-5xl mr-auto flex flex-col items-start justify-start relative z-10"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <motion.h1 className="font-brand tracking-[2px] text-3xl lg:text-6xl font-bold mb-6 mt-8" variants={fadeUp} custom={0}>
            {heroData.title}
          </motion.h1>

          <motion.p className="text-lg xl:text-xl text-foreground/60 tracking-[-1px] font-extralight mb-5 max-w-2xl" variants={fadeUp} custom={1}>
            {heroData.description}
          </motion.p>

          <motion.div className='flex lg:flex-row flex-col lg:items-center lg:justify-center gap-5' variants={fadeUp} custom={2}>
            <Link href={`mailto:${siteConfig.email}`}>
              <Button className='rounded-full tracking-[-0.5px] h-12 pl-7 pr-1'>
                Contact Us
                <div className='h-10 w-14 bg-background rounded-full flex items-center justify-center'>
                  <ArrowUpRight className='text-foreground scale-125' />
                </div>
              </Button>
            </Link>

            <div className='flex items-center justify-center w-max gap-2'>
              <div className='flex items-center -space-x-3'>
                <motion.img src="/images/galileo.jpg" className='shadow w-12 h-12 object-cover rounded-full' variants={fadeUp} custom={3} />
                <motion.img src="/images/mimi.jpg" className='shadow w-12 h-12 object-cover rounded-full' variants={fadeUp} custom={4} />
              </div>

              <motion.div className='text-xs font-light text-foreground/70' variants={fadeUp} custom={5}>
                <div className='text-foreground'>+2</div>
                <p>Trusted Customers</p>
              </motion.div>
            </div>
          </motion.div>

          <motion.div
            className='relative w-full max-w-md mt-14 overflow-visible flex-wrap flex items-center space-x-6'
            style={{ filter: 'brightness(0) invert(1)' }}
            variants={fadeUp}
            custom={6}
          >
            <img src="/svg/react.svg" className='h-13' />
            <img src="/svg/tailwindcss.svg" className='h-18' />
            <img src="/svg/prisma.svg" className='h-7' />
            <img src="/svg/postgresql.svg" className='h-12' />
            <img src="/svg/nextjs.svg" className='h-9' />
          </motion.div>
        </motion.div>
      </Container>
    </section>
  )
}